import { __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator.component.js';
import { defaultProps, propTypes } from './LoadingOverlay.types.js';
import styles from './LoadingOverlay.module.scss.js';

var LoadingOverlay = function (props) {
    var _a;
    var hasBackgroundBlur = props.hasBackgroundBlur, greyAnimation = props.greyAnimation, className = props.className, spinnerClassName = props.spinnerClassName, size = props.size;
    return (React__default.createElement("div", { className: clsx(styles.LoadingOverlay, className, (_a = {},
            _a[styles.LoadingOverlay___blurred] = hasBackgroundBlur,
            _a)), role: "status", "aria-live": "polite", "aria-label": props['aria-label'] },
        React__default.createElement(LoadingIndicator, { greyAnimation: greyAnimation, className: spinnerClassName || '', size: size })));
};
LoadingOverlay.displayName = 'LoadingOverlay';
LoadingOverlay.propTypes = propTypes;
LoadingOverlay.defaultProps = __assign({}, defaultProps);

export { LoadingOverlay as default };
